import styled from 'styled-components';

import { Button } from '@main/pc-core-components/src/Button';
import { sp } from '@main/theme';

/**
 * Button wrapper for constant sizing in Pending Request preview
 */
export const ButtonWrapper = styled(Button)`
  width: 173px;
`;

/**
 * Zipping data message wrapper
 */
export const MessageWrapper = styled.p`
  font-size: ${sp(1.5)};
  color: ${({ theme }) => theme.colors.primary};
`;
